import * as PIXI from 'pixi.js'
import { clear } from '../utils'

export default function ShieldLine(layerInfo, options, container, renderer) {
  clear(container)

  const shieldCols = 60
  const shieldLines = layerInfo.data
  if (!shieldLines) return

  const box = options.box
  const lineBlockWidth = options.width / shieldCols
  const lineBlockHeight = options.height - box.top - box.bottom

  const particleContainer = new PIXI.ParticleContainer(shieldLines.length)
  container.addChild(particleContainer)
  const particleContainerTime = new PIXI.ParticleContainer(shieldLines.length)
  container.addChild(particleContainerTime)

  // time = null texture
  const graphic = new PIXI.Graphics()
  graphic.beginFill(0x18a689, 0.5)
  graphic.lineStyle(1, 0x18a689, 1)
  graphic.drawRect(0, 0, lineBlockWidth, lineBlockHeight)
  const texture = renderer.generateTexture(graphic)
  // time texture
  const graphicTime = new PIXI.Graphics()
  graphicTime.beginFill(0x9acc5e, 0.5)
  graphicTime.lineStyle(1, 0x9acc5e, 1)
  graphicTime.drawRect(0, 0, lineBlockWidth, lineBlockHeight)
  const textureTime = renderer.generateTexture(graphicTime)

  for (let i = 0, j = shieldLines.length; i < j; i++) {
    const shieldLine = shieldLines[i]
    const shieldIndex = shieldLine.blindIndex

    const x = shieldIndex * lineBlockWidth
    const y = box.top

    if (shieldLine.isPermanent) {
      const rectangle = new PIXI.Sprite(texture)
      rectangle.x = x
      rectangle.y = y
      particleContainer.addChild(rectangle)
    } else {
      const rectangle = new PIXI.Sprite(textureTime)
      rectangle.x = x
      rectangle.y = y
      particleContainerTime.addChild(rectangle)
    }
  }
  return container
}
